import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div {
    &:last-child {
      margin-left: 1rem;
    }
  }
`; 